var google = window.google

$('.geolocalisation_button').on('click', function (e) {
  e.preventDefault()
  if (!navigator.geolocation) {
    $('.geo-message').addClass('alert alert-danger')
  } else {
    navigator.geolocation.getCurrentPosition(getStores)
  }
})

$('form[name="searchStores"]').on('submit', function (e) {
  e.preventDefault()
  var firstResult = $('.pac-container .pac-item:first').text()
  var geocoder = new google.maps.Geocoder()

  geocoder.geocode({ 'address': firstResult }, function (results, status) {
    if (status === google.maps.GeocoderStatus.OK) {
      var placeName = results[0]
      $('#user_input_autocomplete_address').val(results[0].formatted_address)
    }

    onPlaceChanged(placeName)
  })
})

function getStores (position) {
  var positions = position

  jQuery.post(
    window.request_ajax_script.ajax_url,
    {
      data: {
        lat: positions.coords.latitude,
        lng: positions.coords.longitude
      },
      action: 'getStores',

    },
    function (r) {
      if (r.data !== undefined && r.data.length > 0) {
        addMarkers(r.data)
      } else {
        clearMarkers()
        map.setCenter(new google.maps.LatLng(positions.coords.latitude, positions.coords.longitude))
        map.setZoom(9)
      }

    }, 'json'
    )
}

var markers = []

function loadMap () {
  var latLng = new google.maps.LatLng(48.734835240950815, 4.859319866271927)
  var mapContainer = document.getElementById('map')

  if (mapContainer) {
    map = new google.maps.Map(document.getElementById('map'), {
      zoom: 7,
      maxZoom: 17,
      center: (latLng),
      styles: [
      {
        'stylers': [
        {
          'saturation': -100
        },
        {
          'gamma': 1
        }
        ]
      },
      {
        'elementType': 'labels.text.stroke',
        'stylers': [
        {
          'visibility': 'off'
        }
        ]
      },
      {
        'featureType': 'poi.business',
        'elementType': 'labels.text',
        'stylers': [
        {
          'visibility': 'off'
        }
        ]
      },
      {
        'featureType': 'poi.business',
        'elementType': 'labels.icon',
        'stylers': [
        {
          'visibility': 'off'
        }
        ]
      },
      {
        'featureType': 'poi.place_of_worship',
        'elementType': 'labels.text',
        'stylers': [
        {
          'visibility': 'off'
        }
        ]
      },
      {
        'featureType': 'poi.place_of_worship',
        'elementType': 'labels.icon',
        'stylers': [
        {
          'visibility': 'off'
        }
        ]
      },
      {
        'featureType': 'road',
        'elementType': 'geometry',
        'stylers': [
        {
          'visibility': 'simplified'
        }
        ]
      },
      {
        'featureType': 'water',
        'stylers': [
        {
          'visibility': 'on'
        },
        {
          'saturation': 50
        },
        {
          'gamma': 0
        },
        {
          'hue': '#50A5D1'
        }
        ]
      },
      {
        'featureType': 'administrative.neighborhood',
        'elementType': 'labels.text.fill',
        'stylers': [
        {
          'color': '#333333'
        }
        ]
      },
      {
        'featureType': 'road.local',
        'elementType': 'labels.text',
        'stylers': [
        {
          'weight': 0.5
        },
        {
          'color': '#333333'
        }
        ]
      },
      {
        'featureType': 'transit.station',
        'elementType': 'labels.icon',
        'stylers': [
        {
          'gamma': 1
        },
        {
          'saturation': 50
        }
        ]
      }
      ],
      disableDefaultUI:
      1
    })

    addMarkers()
  }

}

function clearMarkers () {
  for (var i = 0; i < markers.length; i++) {
    markers[i].setMap(null)
  }

  markers = []
}

function addMarkers (data) {
  if (data !== undefined && data.length > 0) {
    clearMarkers()
    var loop = function () {
      var coord = list[i$1];
console.log(coord)
      coord.urlAddress = encodeURI(coord.street + ',' + coord.zip_code + ',' + coord.city)
      var infowindow = new google.maps.InfoWindow({
        content: '<div id="content">' +
        '<p class="h5">' + coord.name + '</p>' +
        '<p>' + coord.street + ' <br>' + coord.zip_code + ' - ' + coord.city + '</p>' +
        '<p><a target="_blank" href="https://google.com/maps/dir//' + coord.urlAddress + '">itinéraire</a></p>' +
        '<a href="tel:' + coord.phone1 + '">Tel : ' + coord.phone1 + '</a>' +
        '</div>'
      })
      var latLng = new google.maps.LatLng(coord.latitude, coord.longitude)
      var marker = new google.maps.Marker({
        position: latLng,
        icon: '/app/themes/heinrich-bock/dist/images/pin.svg',
        map: map,
        animation: google.maps.Animation.DROP
      })
      marker.addListener('click', function () {
        infowindow.open(map, marker)
      })
      markers.push(marker)
    };

    for (var i$1 = 0, list = data; i$1 < list.length; i$1 += 1) loop();

      var bounds = new google.maps.LatLngBounds()

    for (var i = 0; i < markers.length; i++) {
      bounds.extend(markers[i].getPosition())
    }
    map.fitBounds(bounds)
  }
}

var autocomplete;

function initializeAutocomplete () {
  autocomplete = new google.maps.places.Autocomplete(autocompleteElem, {
    types: ['geocode'],
    componentRestrictions: { country: ['fr', 'lu', 'de', 'at', 'ch'] }
  })
  google.maps.event.addListener(autocomplete, 'place_changed', onPlaceChanged)
}

function onPlaceChanged (placeName) {
  if ( placeName === void 0 ) placeName = false;

  var address = null

  if (placeName) {
    address = placeName
  } else {
    address = autocomplete.getPlace()
  }

  $.getJSON({
    //url: 'https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyAmtTYYUNbF4hIe1_NFORx5VWPH9i28ozg',
    url: 'https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyCZb1A22KRG10FwNcVM3NLmb-ccCrooQHE',
    data: {
      sensor: false,
      address: address.formatted_address
    },
    success: function (data) {
      console.log(data);
      var position = {
        coords: {
          latitude: data.results[0].geometry.location.lat,
          longitude: data.results[0].geometry.location.lng
        }
      }

      getStores(position)
    }
  })
}

var autocompleteElem = document.getElementById('user_input_autocomplete_address')
var map = document.getElementById('map')

google.maps.event.addDomListener(window, 'load', function () {
  loadMap()
  initializeAutocomplete()
})


// WEBPACK FOOTER //
// ./scripts/routes/templateVente.js


// WEBPACK FOOTER //
// ./scripts/routes/templateVente.js